import { ICategory, IMeta } from '@bees-web/core/types'
import Router from 'next/router'
import { MouseEvent } from 'react'

import { setOpenedCollapseName } from '../../actions/faq'
import { HomeInteractive, IAppActions } from '../../interfaces'

import { setBrandsBanners, setBrandsStore } from '../../actions/banners'
import { bannerOnLoadSegment } from '../../utils/bannerSegmentEvents'
import {
  categoryContentLoadedSegments,
  categoryTileClickedSegments,
  categoryTileViewedSegments,
} from '../../utils/categoryTileSegmentEvents'

import { SCREEN_NAME, SECTION_NAME, VS_LINK_PLANNING } from '../../constants'
import settings from '../../constants/brands/index'
import { CategoryTileListItem } from '../../typewriter'
import { formatPathname } from '../../utils/formatPathname'
import { trackAlertDisplayed } from '../../utils/trackAlertDisplayed'
import { trackButtonClicked } from '../topdeals/topDeals'

type IAtribute = {
  attributes: any
}

export type Home = {
  accordion_toggle: IAtribute
  segment_button_clicked: IAtribute
  signed_brands_slider: IAtribute
  toggle_one_trust: IAtribute
  digital_experience: IAtribute
}

export const homeInteractive: HomeInteractive<Home> = (
  dispatch,
  interactiveState,
  globalActions
) => ({
  accordion_toggle: {
    attributes: {
      onClick: (name) => {
        const oldName = interactiveState.state.faq.openedCollapseName
        dispatch(setOpenedCollapseName(name !== oldName ? name : null))
      },
      isOpen: interactiveState.state.faq.openedCollapseName,
    },
  },
  segment_button_clicked: {
    attributes: {
      onClick: (e: MouseEvent<HTMLButtonElement>, meta: IMeta) => {
        const {
          globals: {
            page: { name: screenName, referrer },
          },
        } = interactiveState
        const url = e.currentTarget.getAttribute('href')

        const appActions = globalActions.appActions as IAppActions

        dispatch(
          appActions.trackButtonClicked({
            button_label: meta.buttonLabel,
            button_name: meta.buttonName,
            screen_name: screenName,
            referrer,
            url,
            module_name: null,
            recommendation_type: null,
            store_id: null,
            value_stream: null,
          })
        )
      },
    },
  },
  load_alert_account_alert: {
    attributes: {
      onLoad: () => {
        dispatch(
          trackAlertDisplayed(
            'profile_info_update_entry_point',
            null,
            null,
            'homepage',
            'Information',
            null,
            null,
            null,
            'membership',
            'profile_info_update'
          )
        )
      },
    },
  },
  edit_account_button: {
    attributes: {
      onClick: () => {
        const { referrer } = interactiveState.globals.page
        Router.push('/customer/poc/update')
        dispatch(
          trackButtonClicked({
            button_name: 'profile_update_entry_point_button',
            button_label: 'update',
            referrer,
            screen_name: 'homepage',
            url: window.location.href,
            recommendation_type: null,
            module_name: null,
            store_id: null,
            value_stream: 'membership',
          })
        )
      },
    },
  },
  brands_store: {
    attributes: {
      onLoad: (args) => {
        const { meta } = args
        dispatch(setBrandsStore(meta))
      },
    },
  },
  signed_brands_slider: {
    attributes: {
      brands: (interactiveState?.globals?.header?.partnerCategories || []).map(
        (item) => ({
          moduleGuid: item.categoryID,
          moduleName: item.name,
          brandUrlSuffix: item.uri,
          categories: item.categories,
          url: '/category/',
          backgroundImage: item?.image,
        })
      ),
      isClickable: true,
      onClickSegment: (_e: MouseEvent<HTMLButtonElement>, meta: IMeta) => {
        const dataSegment = {
          position: meta.position,
          referrer: interactiveState.globals.page.referrer,
          screen_name: 'homepage',
          store_id: meta?.storeId,
          tile_name: meta.name,
          value_stream: 'HOMEPAGE',
          vendor_list: [
            { vendor_name: meta?.vendorName, vendorid: meta?.vendorId },
          ],
        }

        categoryTileClickedSegments(dataSegment, dispatch)
      },
      onViewedSegment: (meta: IMeta) => {
        const {
          globals: {
            page: { name: screenName, referrer },
          },
        } = interactiveState
        const formatedReferrer = formatPathname(referrer)
        const extractCategoryIdFromUrl = (url: string): string | null => {
          return url?.split('category/')[1]
        }

        const partnerCategoriesMap = new Map(
          interactiveState?.globals?.header?.partnerCategories.map((c) => [
            c.uri,
            c,
          ])
        )

        const formatTileList = (
          datas: ICategory[] | HTMLAnchorElement[],
          type?: string
        ): CategoryTileListItem[] => {
          return (datas || []).map((element, i) => {
            const id =
              type === 'carousel'
                ? extractCategoryIdFromUrl(element.href)
                : null
            const category = id ? partnerCategoriesMap.get(id) : element
            const index = currentIndex + i + 1

            return {
              position: index,
              tile_name: (category || element)?.name || null,
              vendor_list: ((category || element)?.vendorIds || []).map(
                (u: string) => ({
                  vendorId: u || null,
                })
              ),
            }
          })
        }

        const { currentIndex, storeId, slidesToScroll } = meta

        const contentLoadedProps = {
          screen_name: SCREEN_NAME,
          value_stream: VS_LINK_PLANNING,
          section_name: SECTION_NAME,
          store_id: storeId,
          referrer: formatedReferrer,
        }

        categoryContentLoadedSegments(contentLoadedProps, dispatch)

        let categories: CategoryTileListItem[] = []

        const activeElements = Array.from(
          document.querySelectorAll('.slick-active .brand-slide a')
        ) as HTMLAnchorElement[]

        if (activeElements.length > 0) {
          categories = formatTileList(activeElements, 'carousel')
        } else if (
          interactiveState?.globals?.header?.partnerCategories.length > 0
        ) {
          categories = formatTileList(
            interactiveState?.globals?.header?.partnerCategories.slice(
              currentIndex,
              slidesToScroll
            )
          )
        }

        if (!categories.every((c) => !c.tile_name)) {
          const dataSegment = {
            category_tile_list: categories,
            referrer,
            screen_name: screenName,
            store_id: storeId,
            value_stream: 'HOMEPAGE',
          }

          categoryTileViewedSegments(dataSegment, dispatch)
        }
      },
      settings: settings(interactiveState),
    },
  },
  brands_loader: {
    attributes: {
      visible:
        interactiveState?.globals?.header?.partnerCategories?.length > 0
          ? true
          : false,
    },
  },
  toggle_one_trust: {
    attributes: {
      href: '#',
      onClick: (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        if (window.hasOwnProperty('OneTrust')) {
          window['OneTrust'].ToggleInfoDisplay()
        }
      },
    },
  },
  digital_experience: {
    attributes: {
      onLoad: () => {
        const listener = (event) => {
          if (event.data === 'closeMobileButton') {
            Router.push('/cms/index/home')
          }
        }

        window.addEventListener('message', listener)
      },
    },
  },
  onload_brands: {
    attributes: {
      dependencies: [interactiveState.globals.authentication.storeId],
      onLoad: (meta) => {
        const {
          response: { slides = [] },
        } = meta
        dispatch(setBrandsBanners(slides))
      },
    },
  },
  wrapper_brands: {
    attributes: {
      style: {
        height: interactiveState.state.banners.heightBrands,
        display:
          interactiveState?.globals?.header?.partnerCategories?.length > 0
            ? 'flex'
            : 'none',

        justifyContent: 'center',
      },
    },
  },
})
